<template>
    <div>
        <!-- Navbar beginning -->
        <nav class="navbar is-dark">
            <div class="navbar-brand">
                <a class="navbar-item" @click="goToFilter(mainItem, null)"><img src="../../assets/logoKDCAbox-white.svg" class="logo"></a>
                <div :class="hamburguerClass" @click="toggleHamburguer">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>

            <div :class="navBarClass">
                <div class="navbar-start">

                </div>

                <div class="navbar-end">
                    <div v-for="item in routes"
                       :key="item.path"
                        class="navbar-item has-dropdown is-hoverable">
                      <a :class="'navbar-link'"
                         @click="goToFilter(item,null)">
                        {{item.name}}
                      </a>
                      <div class="navbar-dropdown is-boxed">
                        <a class="navbar-item"
                           @click="goToFilter(item,null)">
                          Todos
                        </a>
                        <hr class="navbar-divider">
                        <a v-for="client in clients" :key="client.idClient"
                           class="navbar-item"
                           @click="goToFilter(item,client)">
                          {{client.name}}
                        </a>
                      </div>
                    </div>
                    <div class="navbar-item has-dropdown is-hoverable">
                        <a class="navbar-link">
                            {{userName}}
                        </a>
                        <div class="navbar-dropdown is-boxed">
                            <a class="navbar-item" @click="logout">
                                Logout
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </nav>
        <!-- End of Navbar-->

        <!-- Hero section -->
        <!--<section class="hero is-primary is-small">
            <div class="hero-body">
                <p class="title">
                    {{routeName}}
                </p>
                <p class="subtitle">
                    {{routeDescription}}
                </p>
            </div>
        </section>-->

    </div>

</template>

<script>
import Auth from '../../models/auth'

export default {
  data () {
    return {
      menuActive: false,
      hide: true,
      items: [],
      mainItem: null,
      user: {
        'name': null
      },
      clients: [],
      path: null
    }
  },

  created () {
    this.setRoutes()
    this.getClients()
  },

  computed: {
    routes () {
      return this.items
    },
    hamburguerClass () {
      return this.menuActive ? 'navbar-burger burger is-active' : 'navbar-burger burger'
    },
    navBarClass () {
      return this.menuActive ? 'navbar-menu is-active' : 'navbar-menu burger'
    },
    userName () {
      return localStorage.getObject('user.name', false)
    }
  },

  methods: {
    toggleHamburguer () {
      this.menuActive = !this.menuActive
    },
    toggleModal () {
      this.showModal = !this.showModal
    },
    isActive (item) {
      return this.$route.path === item.path
    },
    logout () {
      // this.auth.logout()
      Auth.deleteAuthorization()
      this.$router.push('/login')
    },
    setRoutes () {
      this.items.push({name: 'Chatbots', path: '/clients'})
      this.items.push({name: 'Entrenamiento', path: '/training'})
      this.items.push({name: 'Conversaciones', path: '/chats'})
      this.items.push({name: 'Analítica', path: '/kpis'})
      this.mainItem = this.items[0]
    },
    getClients () {
      this.api.post('/ClientGetList').then(response => {
        this.clients = response.clients
      })
    },
    goToFilter (item, client) {
      this.path = item.path
      if (client) {
        switch (item.name) {
          case this.items[0].name:
            this.path = item.path + '/' + client.idClient + '/intents'
            break
          case this.items[1].name:
            this.path = '/clients/' + client.idClient + item.path
            break
          case this.items[2].name:
            this.path = '/clients/' + client.idClient + item.path
            break
          case this.items[3].name:
            this.path = '/clients/' + client.idClient + item.path
            break
          default:
            break
        }
      }
      this.$router.push(this.path)
      window.location.reload()
    }
  }
}
</script>

<style>

    img.brand {
        width: 150px !important;
        display: block;
        margin: 0 auto
    }

    img.logo {
        width: auto;
        height: 40px;
    }

    .navbar.is-dark {
        background-image: linear-gradient(141deg, #1f191a 0%, #363636 71%, #46403f 100%);
    }

    .navbar-item, .navbar-link {
      padding: 0.8rem 0.75rem;
    }

    .navbar-item img {
      max-height: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/components/navigation/NavBar.vue